import { IsMobileDevice } from 'source/app/domain/Device/Helpers/IsMobile';
import { StyleClass } from '../Styles/CSS';

export const sharedFormStyleClass = StyleClass(`sharedFormStyle`, {
	transition:
		IsMobileDevice() ? '' : `width 0.5s, opacity 1s, border-color 0.5s, box-shadow 0.5s`
});

export const dynamicOpacityFormClass = StyleClass(`dynamicOpacityForm`, {
	opacity: 0.5,
	':focus': { opacity: 1 }
});
